var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMgYenLogoWhitePos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 766.29 284.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.23,179.85a13,13,0,0,1-7.89-2.68,54,54,0,1,1,86.81-42.87,13,13,0,0,1-26,0,28,28,0,1,0-45,22.25,13,13,0,0,1-7.91,23.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.21,181.28a12.91,12.91,0,0,1-7.26-2.23,54,54,0,1,1,84.19-44.75,13,13,0,1,1-26,0,28,28,0,1,0-43.66,23.23,13,13,0,0,1-7.29,23.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.26,181.32A12.92,12.92,0,0,1,227,179.1a54,54,0,1,1,84.13-44.8,13,13,0,0,1-26,0,28,28,0,1,0-43.64,23.25,13,13,0,0,1-7.26,23.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.24,175.31c.74-.63,1.47-1.28,2.18-1.95a53.67,53.67,0,0,0,16.7-37.8,13,13,0,1,0-26-.61,28,28,0,1,1-28-28.67h1a13,13,0,0,0,.3-26,54,54,0,1,0-2.53,108l1.27,0h0a28,28,0,1,1-28,28,13,13,0,1,0-26,0,54,54,0,1,0,89.07-41Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 409.15,
    cy: 169.34,
    r: 11.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.15,81.4c-7,0-10.93,4.66-13.07,10.39l-17.36,48.33L461.24,91.61C458.92,85.16,455,81.4,448.17,81.4c-7.52,0-13.43,5.38-13.43,13.08a20,20,0,0,0,1.43,6.26l35.76,69.16c-5.26,12.25-15.76,15.11-21.08,8.76a12.47,12.47,0,0,0-17.57-1.53c-5.27,4.42-5.22,11.75-1.53,17.56,6.6,10.4,22.34,12.11,33.29,9.79,18-3.8,27.63-18.67,34-34.38,9-22.22,18-47,27.46-69.06.09-.22.19-.44.28-.65A20.54,20.54,0,0,0,528,93.94,12.66,12.66,0,0,0,515.15,81.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.46,80.69c-27.94,0-47.46,22.56-47.46,50V131c0,29.37,21.31,49.61,50.14,49.61,14,0,24.9-4.48,33.31-11.64a10.7,10.7,0,0,0,3.58-8.06,10.4,10.4,0,0,0-10.56-10.75,10.18,10.18,0,0,0-6.63,2.15,31.41,31.41,0,0,1-19.34,6.45c-12.18,0-20.77-6.45-23.46-18.81H613c7.16,0,12.71-5.19,12.71-13.07C625.66,107,611.51,80.69,579.46,80.69ZM558.68,123c2.15-12.36,9.49-20.41,20.78-20.41,11.46,0,18.62,8.23,20.23,20.41Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.53,80.69c-13.79,0-21.85,7.34-28.12,15.4V95a13.61,13.61,0,1,0-27.22,0v70.92a13.61,13.61,0,1,0,27.22,0v-41c0-12.89,6.63-19.52,17-19.52S699.9,112,699.9,124.92v41a13.61,13.61,0,0,0,27.22,0V116.32C727.12,94.3,715.13,80.69,694.53,80.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgYenLogoWhitePos);
export default __webpack_public_path__ + "static/media/mg-yen_logoWhite_pos.d6fa2ded4c9325094152d4014d93435b.svg";
export { ForwardRef as ReactComponent };